export enum DragDropTypes {
  NEW = "NEW_INGREDIENT",
  SORT = "SORT_INGREDIENT",
}
